import { Injectable } from "@angular/core";
import { Subscription } from 'rxjs';
import { WorklocationServiceProvider } from "../../../providers/worklocation/worklocation.service";
import { AccessAuthorizationApiProvider } from "../../../shared/nestjs/access-management/access-authorization-api";
import { ResponseGetJobGradeDto } from "../../../shared/nestjs/gd-only/dto/jobGrade.dto";
import { ResponseWorklocationDto } from "../../../shared/nestjs/gd-only/dto/worklocation.dto";
import { CostCenterNestApi } from "../../../shared/nestjs/gd-only/services/cost-center.api";
import { JobGradeApi } from "../../../shared/nestjs/gd-only/services/job-grade.api";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { ResponsePaging } from "../../../shared/nestjs/nest-responses";

@Injectable()
export class GroupMemberBloc {

  private subscriptions: Array<Subscription> = [];

  constructor(
    private worklocationServiceProvider: WorklocationServiceProvider,
    private costCenterNestApi: CostCenterNestApi,
    private personalNestApi: PersonalNestApi,
    private jobGradeApi: JobGradeApi,
    private accessAuthorizationApi: AccessAuthorizationApiProvider,
  ) {

  }

  public dispose() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  findWorkLocation(payload: { page: number, limit: number, companyId: any }) {
    return new Promise<ResponsePaging<ResponseWorklocationDto>>(async (resolve, reject) => {
      try {
        const result = await this.worklocationServiceProvider.findWorkLocation(payload);
        resolve(result);
      } catch (error) {
        reject(error)
      }
    })
  }

  getCostCenter() {
    return new Promise(async (resolve, reject) => {
      this.subscriptions.push(
        this.costCenterNestApi.getCostCenter()
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getMaritalStatus() {
    return new Promise(async (resolve, reject) => {
      this.subscriptions.push(
        this.personalNestApi.maritalList()
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getJobGrade() {
    return new Promise<ResponseGetJobGradeDto>(async (resolve, reject) => {
      this.subscriptions.push(
        this.jobGradeApi.getJobGrade()
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getDynamicColumn() {
    return new Promise(async (resolve, reject) => {
      this.subscriptions.push(
        this.accessAuthorizationApi.getDynamicColumn()
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }


}


// WEBPACK FOOTER //
// ./src/bloc/settings/function-authorization/group-member.bloc.ts